import styled from 'styled-components'

export const DetailsMenuButtonContainer = styled.button`
  display: block;
  border-radius: 10px;
  min-height: 80px;
  padding: 1.2rem 1.5rem;
  width: 230px !important;
  color: var(--dark);
  background: none;
  text-align: left;
  text-transform: uppercase;
  width: 100%;
  transition all 400ms;

  &.selected {
    color: ${props => props.color};
    background: ${props => props.bgColor};
    pointer-events: none;
    
    span {
      font-weight: 600;
    }
  }

  &:not(:last-child) {
    margin-bottom: 1rem;
  }

  span {
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
  }
`
